import { render, staticRenderFns } from "./ConversationListItem.vue?vue&type=template&id=33bfcec4&scoped=true"
import script from "./ConversationListItem.vue?vue&type=script&lang=js"
export * from "./ConversationListItem.vue?vue&type=script&lang=js"
import style0 from "./ConversationListItem.vue?vue&type=style&index=0&id=33bfcec4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33bfcec4",
  null
  
)

export default component.exports